import { Component, OnInit } from '@angular/core';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, THEME } from 'ng-wizard';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';

@Component({
  selector: "app-content-and-learing-setup",
  templateUrl: "./content-and-learing-setup.component.html",
  styleUrls: ["./content-and-learing-setup.component.scss"],
})
export class ContentAndLearingSetupComponent implements OnInit {
  engagementId: any = "";
  engagementType: any = "";
  createEngagementFlag: boolean = true;
  whitelistFlag: boolean = false;
  whitelistObj: any;
  localFlagsData: any;
  localData: any;
  zoneData: any = [];
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
  };
  constructor(
    private wizardService: NgWizardService,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration
  ) {
    this.localFlagsData = JSON.parse(
      localStorage.getItem("engagementStepFlags")
    );
    this.localData = JSON.parse(localStorage.getItem("engagementDetail"));
  }

  ngOnInit() {
    if (this.localData.is_edit) {
      this.createEngagementFlag = this.localFlagsData.createEngagementFlag;
      this.whitelistFlag = this.localFlagsData.whitelistFlag;
      this.engagementId = this.localData.task_id;
      this.engagementType = this.localData.engagement_type_id;
      this.engagementCreated(true);
    }
  }
  getEngagementId(e) {
    this.engagementId = e;
  }

  getEngagementTypeId(e) {
    this.engagementType = e;
  }
  engagementCreated(e) {
    console.log(e);
    this.whitelistFlag = true;
    setTimeout(() => {
      this.wizardService.next();
    }, 300);
  }

  whiteListed(e) {
    console.log(e);
    setTimeout(() => {
      this.wizardService.next();
    }, 300);
  }

  getWhitelistObj(e) {
    this.whitelistObj = e;
    this.fetchZoneTypeData(e.zn_type);
  }

  fetchZoneTypeData(zone_type) {
    if (zone_type == 1) {
      this.apiService.get(this.apiConfig.configGetRegion).subscribe((res) => {
        this.zoneData = res["data"].region;
        console.log("regionData", this.zoneData);
      });
    } else if (zone_type == 2) {
      this.apiService.get(this.apiConfig.configGetStates).subscribe((res) => {
        this.zoneData = res["data"].state;
        console.log("SateData", this.zoneData);
      });
    } else {
      this.apiService.get(this.apiConfig.configGetCities).subscribe((res) => {
        this.zoneData = res["data"].cities;
        console.log("cityData", this.zoneData);
      });
    }
  }

  // previous(): void {
  //   this.wizardService.previous();
  // }

  // next(): void {
  //   this.wizardService.next();
  // }

  // submit(): void {
  //   alert('Form submitted');
  // }

  // onStepChanged(args: StepChangedArgs): void {
  //   console.log(args.step);
  // }

  // onStepValidated(args: StepValidationArgs): void {
  //   console.log(args.toStep);
  //   console.log(args.direction);
  // }
}
